module.exports = __webpack_public_path__ + "img/arrow-blue.e176ab7f.png";